import { render, staticRenderFns } from "./diff_demo.vue?vue&type=template&id=45b00eb0&scoped=true&"
import script from "./diff_demo.vue?vue&type=script&lang=ts&"
export * from "./diff_demo.vue?vue&type=script&lang=ts&"
import style0 from "./diff_demo.vue?vue&type=style&index=0&id=45b00eb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b00eb0",
  null
  
)

export default component.exports